module.exports = __webpack_public_path__ + "media/images/proposal/hall-list/proposal-halllist-3-119f9a97b9f753816baafca2fb53866e.png";